import React, { PropsWithChildren } from 'react';

export interface HeaderSectionProps extends PropsWithChildren {
  title?: string;
}

export const HeaderSection = ({ title, children }: HeaderSectionProps) => {
  return (
    <div className="mt-6 pb-16 text-center">
      <div>
        <h1 className="heading-2" dangerouslySetInnerHTML={{ __html: title }}></h1>
        {!!children && <div className="pt-2.5 text-base">{children}</div>}
      </div>
    </div>
  );
};
